export default __webpack_public_path__ + "static/media/map-icon.27b14b20.svg";